import { useTheme } from '@mui/material';

export const BenefitProfileIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M49.3247 50.2036H16.6141C15.2041 50.2036 14.0487 49.0843 14.004 47.675C13.9152 44.8769 14.7281 42.1244 16.3228 39.8235L17.8441 37.6284C18.5254 36.6454 19.8844 36.4149 20.8552 37.1135C28.134 42.3517 37.9729 42.371 45.2517 37.1328C46.2335 36.4263 47.6057 36.6765 48.2749 37.684L49.7741 39.941C51.2579 42.1749 52.0494 44.797 52.0494 47.4789C52.0494 48.9837 50.8295 50.2036 49.3247 50.2036Z"
                fill={primaryBackground}
            />
            <circle cx="32.375" cy="21.875" r="11.375" fill={primaryBackground} />
            <path
                d="M46.7834 47.8333H46.55"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35 38.43C31.8779 39.5377 28.538 39.8911 25.2533 39.4612C21.9685 39.0314 18.832 37.8305 16.1 35.9567C15.6181 35.6253 15.0294 35.4869 14.4503 35.569C13.8713 35.6511 13.3441 35.9477 12.9734 36.4C10.621 39.3049 9.33619 42.9288 9.33337 46.6667C9.33337 47.2855 9.57921 47.879 10.0168 48.3166C10.4544 48.7542 11.0479 49 11.6667 49H35"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M46.6667 37.3333V30.3333M39.6667 18.6667C39.6667 20.9741 38.9825 23.2297 37.7005 25.1483C36.4186 27.0669 34.5965 28.5622 32.4647 29.4453C30.3329 30.3283 27.9871 30.5593 25.724 30.1092C23.4609 29.659 21.3821 28.5479 19.7505 26.9162C18.1189 25.2846 17.0077 23.2058 16.5576 20.9427C16.1074 18.6796 16.3384 16.3338 17.2215 14.202C18.1045 12.0702 19.5998 10.2481 21.5184 8.96619C23.437 7.68424 25.6926 7 28 7C31.0942 7 34.0617 8.22916 36.2496 10.4171C38.4375 12.605 39.6667 15.5725 39.6667 18.6667Z"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
